import complete from "./complete";
import delayed from "./delayed";

export const step = {
  ...complete,
  ...delayed,
};
